import { render, staticRenderFns } from "./AssignIp.vue?vue&type=template&id=d90e3470&"
import script from "./AssignIp.vue?vue&type=script&lang=js&"
export * from "./AssignIp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports